module.exports = __webpack_public_path__ + "__assets__/img/news-swiper.7962b9d4.png";